import React, { useEffect } from "react";

const About = (props) => {
  useEffect(() => {
    document.title = "About Me";
  }, []);

  let mycolor = "#9BAB9A";

  if (props.color !== mycolor) props.backColor(mycolor);

  return (
    <div>
      <div
        className="ui basic padded segment"
        style={{
          margin: "10px 0px 0px 20px",
          maxWidth: "550px",
          letterSpacing: "0.3px",
          fontSize: "15.3px",
          color: "#2E3419",
          fontFamily: "Roboto Slab",
        }}
      >
        <h1
          className="ui header"
          style={{ fontSize: "35px", color: "#055118" }}
        >
          About📋🤓
        </h1>
        <p>
          Hi, My name is Saksham Manocha and I am a 21-year-old Skin Robot🤖 who
          happens to be a Full Stack Web Developer👨🏻‍💻(MEAN/MERN Stack), M.L
          Enthusiast and is soon to hold Electronics and Communication
          Engineering degree ( 2020).
          <u>
            <a
              href={require("../statics/resume.pdf")}
              download
              style={{ color: "black" }}
            >
              My Resume📥
            </a>
          </u>
        </p>
        <p>
          {/* Happens to have traits like Positive, Hardworking, Adaptable and all
          others that people tend to put on their profiles 🧐. Also the traits that
          I don't possess are Boring,Procastinator,Lazy🥱and all others that
          people don't put on their profiles.
          <br />
          <u>Side Note</u>: To those who didn't get that,it was a joke😉. I was resisting
          myself to explain it but then remembered its about my future,so can't
          take a risk.
          <br/> */}
          Skilled in Javascript and Python as programming languages. Specializes
          in Node JS for backend purposes, Angular/ReactJS for frontend🧑‍🎨 and
          MongoDB/MySQL for database design and management🗃️ with working
          knowledge in microservices architecture, CI/CD, and Redis caching.
          <br />
          Also Has keen interest in Machine Learning🎰 specifically
          image-related algorithms like CNN, GAN, etc.
          <br />
          Positive, Hard Working Individual with grit to learn new technologies
          really fast!!
        </p>
        <p>
          OTHER INTERESTS:
          <br />
          Massive Liverpool Fan (We are gonna be The Champions of England
          👑🏆🎉). Can talk about football ⚽ anytime,anywhere and with anyone
          and also kinda good at Badminton🏸 as well. Avid Book reader, Loves
          watching TV Series(Dark is best web series EVER ⏳,fight me!!). and
          music lover🎵 - Afrojack/Adele/Ed Sheeran/NF and pretty much everyone
          else!!!!
        </p>
      </div>
    </div>
  );
};

export default About;
